import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import EndForm from 'component/organism/workflow/forms/endForm/EndForm';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

const EndModal = ({ isOpen, onClose, title, id }) => {
  const { workflowData, setWorkflowData, selectedNode } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      trigger: selectedNode?.data?.trigger || '',
      keyword: selectedNode?.data?.keyword || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      trigger: Yup.string().required('Required'),
      keyword: Yup.string().when('trigger', {
        is: (value) => value == '1',
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const updatedNodes = workflowData?.nodes?.map((node) =>
        node.id === id ? { ...node, data: values } : node
      );
      setWorkflowData((prev) => {
        return {
          ...prev,
          nodes: updatedNodes,
        };
      });
      onClose();
      resetForm();
      setSubmitting(false);
    },
  });

  const handleSubmit = () => {
    formik.handleSubmit();
  };
  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <EndForm />
      </FormikProvider>
    </RightSlider>
  );
};

export default EndModal;
